import React from 'react'
import { observer } from 'mobx-react-lite'
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import PageHeading from './../../components/shared/PageHeading.component'
import MediaUploaderButton from './../../components/modals/MediaUploaderModal/button.component'
import UserProfileService from './../../shared/services/UserProfile.service'
import { getTeamLogo } from './../../shared/utilities/getTeamLogo.function'
import PLACEHOLDER from './../../assets/images/user_placeholder.png'

/*
 * Agency Branding (UAD-3667).
 *
 * A white-label leader uploads their own brand logo here. It is stored per
 * leader (white_label_brands, keyed by their user id) and shown to the agents
 * they enroll on the enrollment, dashboard and subsite pages. The logo path is
 * resolved onto the profile as `white_label_logo` (self-inclusive).
 */
const AgencyBranding = observer(() => {
  // Local state so the preview updates immediately after an upload.
  const [logo, setLogo] = React.useState(UserProfileService.get('white_label_logo') || '')

  const onSuccess = filepath => {
    UserProfileService.set('white_label_logo', filepath)
    setLogo(filepath)
  }

  return (
    <MDBContainer fluid className='content-wrapper mb-4'>
      <MDBRow>
        <MDBCol md='5'>
          <div className='mb-3'>
            <img
              alt='Agency Logo'
              src={logo ? getTeamLogo(logo) : PLACEHOLDER}
              className='img-fluid'
              style={{ maxHeight: '160px' }}
            />
          </div>
          <MediaUploaderButton
            block
            size='sm'
            type='button'
            label={
              <>
                Upload Agency Logo &nbsp;
                <MDBIcon icon='cloud-upload-alt' />
              </>
            }
            modalConfig={{
              uploadType: 'white_label_logo',
              modalContentTop: (
                <div className='text--center fw--500'>
                  <h6 className='fw--500'>Upload your agency logo (PNG).</h6>
                </div>
              ),
              validationRules: { contentType: ['image/png'] },
            }}
            onSuccess={onSuccess}
          />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  )
})

class AgencyBrandingPage extends React.Component {
  render() {
    return (
      <DashboardLayout>
        <main id='AgencyBrandingPage' className='mainSection pb-5'>
          <MDBContainer fluid className='mt-5'>
            <PageHeading
              label='Agency Branding'
              url={this.props?.match?.url}
              from={this.props?.location?.state?.from}
            />
            <p className='mt-3'>
              Upload your agency logo. It replaces USABG branding on the enrollment and back-office pages your
              white-label agents see.
            </p>
            <AgencyBranding />
          </MDBContainer>
        </main>
      </DashboardLayout>
    )
  }
}

export default AgencyBrandingPage
